import axios from "axios"

export function getCountries() {
    const config = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    };
    return axios.get(process.env.VUE_APP_API_URL + "Form/getallcountry", config);
}

export function getStates(countryId) {
    const config = {
        params: {
            countryId: countryId,
        },
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    };
    return axios.get(process.env.VUE_APP_API_URL + "Form/getallstate", config);
}

export function getCities(statesId) {
    const config = {
        params: {
            statesId: statesId,
        },
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    };
    return axios.get(process.env.VUE_APP_API_URL + "Form/getallcity", config);
}

export function getNationalities() {
    const config = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    };
    return axios.get(process.env.VUE_APP_API_URL + "Form/getallnationality", config);
}

/** */

//Form Kayıt
export function postForm(data) {
    return axios.post(process.env.VUE_APP_API_URL + "Class/studentformadd", data);
}